import { useField } from "@unform/core";
import { forwardRef, useEffect, useRef, useState } from "react";
import { useFormContext, useFormState } from "react-hook-form";

import Affix from "../../Components/Affix";
import HelpText from "../../Components/HelpText";
import * as S from "./styles";

// eslint-disable-next-line react/display-name
export const TextArea = forwardRef(({ gridArea, margin, ...props }, ref) => {
  const inputRef = useRef(null);
  const { fieldName, defaultValue, registerField } = useField(props?.name);
  const [state, setState] = useState();

  const methods = useFormContext();
  const { setFocus, control } = methods ? methods : {};

  const { errors } = methods
    ? useFormState({
        control,
      })
    : {};

  useEffect(() => {
    if (errors && errors[fieldName]) {
      setFocus(fieldName);
    }
  }, [errors]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: ref ? ref.current : inputRef.current,
      path: "value",
    });
  }, [fieldName, registerField]);

  const getInput = () => {
    return (
      <S.InputStylesStructure
        id={fieldName}
        ref={ref ? ref : inputRef}
        defaultValue={defaultValue}
        required={props?.required}
        size={props?.size}
        {...props}
      />
    );
  };

  return (
    <S.Wrapper gridArea={gridArea} margin={margin} {...props}>
      {props?.label && (
        <S.Label htmlFor={fieldName} size={props?.size}>
          {props?.label} {props?.required && <S.RequiredDot />}
        </S.Label>
      )}
      <S.InputWrapper state={state} {...props}>
        {props?.prefix && (
          <Affix
            prefix="true"
            {...props?.prefix}
            size={props?.size}
            disabled={props.disabled}
          />
        )}
        {getInput(props?.mask)}
        {props?.suffix && (
          <Affix
            suffix="true"
            {...props?.suffix}
            size={props?.size}
            disabled={props.disabled}
          />
        )}
      </S.InputWrapper>
      {errors && errors[fieldName] ? (
        <HelpText
          id={fieldName}
          text={errors[fieldName]?.message}
          size={props?.size}
          setState={setState}
        />
      ) : null}
    </S.Wrapper>
  );
});
